import declare from "dojo/_base/declare";
import StateActionController from "csi/breadcrumb/StateActionController";
import _StartApprovalWorkflowMixin from "csi/breadcrumb/_StartApprovalWorkflowMixin";
import session from "csi/session";
import { setLocationHash } from "csi/utility/routerUtility";

const StartApprovalActionController = declare([StateActionController, _StartApprovalWorkflowMixin], {

});

export = StartApprovalActionController;
